import { gql } from 'apollo-boost';

const CHANNELS = gql`
  query {
    providerChannels
  }
`;

export default CHANNELS;
